<template>
  <div v-if="question" class="question-solution">
    <div class="question-container">
      <div v-if="question.image_large" class="image-container">
        <img v-if="image" key="q-img" class="question-image" :src="image" />
      </div>
      <h1>{{ text.question_text | clean }}</h1>
      <div class="answer-container">
        <div v-for="(a, index) of answers" :key="a.num" :data-index="index">
          <div class="checkbox-container">
            <div
              :class="[
                a.is_correct == '1' ? 'correct' : '',
                a.is_correct == '0' ? 'incorrect' : '',
                'custom-check',
              ]"
            >
              <div :class="[a.is_checked ? 'checked' : '', 'fill']">
                <div v-if="a.is_correct == '1' && a.is_checked" class="icon">
                  ✓
                </div>
                <div
                  v-else-if="!a.is_correct == '0' && a.is_checked"
                  class="icon"
                >
                  ✖
                </div>
              </div>
            </div>
            <span>{{ a.answer_text | clean }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCheckbox from "@/components/CustomCheckbox.vue";

export default {
  name: "QuestionSolution",
  components: {
    CustomCheckbox,
  },
  filters: {
    clean(value) {
      value = value ? value : "";
      return value.toString().replace(/\[|\]/gi, "");
    },
  },
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      language: "DE",
    };
  },
  computed: {
    answers() {
      let answers = this.question.answers[this.language].map((a, i) => {
        a.is_checked = this.checked.includes(parseInt(a.num, 10));
        return a;
      });
      return answers;
    },
    text() {
      return this.question.text[this.language];
    },
    image() {
      return (
        process.env.VUE_APP_FLL_ROOT_API + "/media/" + this.question.image_large
      );
    },
    checked() {
      let checked = this.question.user_answer_key.split(",");
      let result = [];
      checked.forEach((c, i) => {
        console.log(c, i);
        if (c == 1) result.push(i);
      });
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.question-solution {
  h1 {
    font-size: 14px;
    color: $green;
    margin-bottom: 10px;
  }

  .checkbox-container {
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    position: relative;
    user-select: none;

    .custom-check {
      width: 22px;
      height: 22px;
      transition: all 0.3s ease-in-out;
      border: 1px solid $blue;
      display: inline-block;
      width: 100%;
      max-width: 22px;
      height: 22px;
      z-index: 1;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 3px;
      user-select: none;
      margin-right: 10px;

      &.correct {
        background-color: $green;
      }
      &.incorrect {
        background-color: $red;
      }

      .fill {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        color: #ffffff;
        user-select: none;

        .icon {
          display: flex;
          align-items: center;
          justify-content: space-around;
          padding: 2px;
          font-size: 10px;
          user-select: none;
          color: #ffffff;
        }

        &.checked {
          background-color: $blue;
          user-select: none;
        }
      }
    }
  }
}
</style>
